export const competencyHeaders = {
    "A1.1": "Rättsliga och administrativa krav",
    "A1.2": "Yrkesansvar",
    "A1.3": "Etiska principer",
    "A1.4": "Vägledningsrelation",
    "A2.1": "Teoretisk kunskap",
    "A2.2": "Tillämpning av teoretiska kunskaper",
    "A2.3": "Forskning inom vägledningsområdet",
    "A3.1": "Reflekterande yrkesutövning",
    "A3.2": "Utveckling av personlig kompetens",
    "A4.1": "Tydlig kommunikation",
    "A4.2": "Målinriktad interaktion",
    "A4.3": "Reflexiv kommunikation",
    "A4.4": "Professionell kommunikation",
    "A5.1": "Teknologi i vägledning",
    "A5.2": "Teknologi i vägledningsprocessen",
    "A5.3": "Gemensam användning av teknologi",
    "A5.4": "Systematisk utveckling av användningen av teknologi i vägledningen",
    "B1.1": "Vägledningsprocessens delar",
    "B1.2": "Vägledning som process",
    "B1.3": "Vägledningsprocessens resultat och effekter",
    "B2.1": "Utvecklings- och livsloppsorienterade teorier",
    "B2.2": "Teorier om karriärutveckling",
    "B2.3": "Samhälle och arbetsliv",
    "B2.4": "Vägledningsteorier",
    "B2.5": "Livslångt och kontinuerligt lärande",
    "B2.6": "Vägledningsfilosofi",
    "B3.1": "Informationssökning och -hantering",
    "B3.2": "Reflektera och sätta upp mål",
    "B3.3": "Kundcentrerad vägledningsprocess",
    "B3.4": "Utvärdering",
    "C1.1": "Vägledning i samhället",
    "C1.2": "Vägledning av livslång karaktär",
    "C1.3": "Vägledningens ställning och positionering",
    "C2.1": "Organisationer och nätverk",
    "C2.2": "Strategiskt lärande",
    "C3.1": "Multiprofessionellt nätverkande",
    "C3.2": "Sektorsövergripande nätverk",
    "C4.1": "Planering och organisering",
    "C4.2": "Kvalitetsbedömning och uppföljning",
    "C4.3": "Kontinuerlig utveckling",
  };